export default __webpack_public_path__ + "static/char-s-52-ja-0c47633fa259eba820b92f3d782263a1.webp";